
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { wxORzfb } from "../common/js/config"
export default {
components: {
Tab,
TabItem,
Group,
Cell
},
data() {
return {
tabSelected: 0,
publicName: "公众号",
publicCodeImg: "../../static/images/oouyan_qr.png",
checkZfb: "通过添加客服微信，或者",
customProblemShow: false,
customerServiceShow: true,
customProblemList:[]
}
},
created() {
if (wxORzfb == "wx") {
this.publicName = "公众号";
this.publicCodeImg = "../../static/images/oouyan_qr.png";
this.checkZfb = "通过添加客服微信，或者";

} else if(wxORzfb == "zfb") {
this.publicName = "生活号";
this.publicCodeImg = "../../static/images/oouyan_alipay_qr.jpg";
this.checkZfb = "";

}
},
methods: {
customerService () {
this.customerServiceShow = true
this.customProblemShow = false
},
customProblem () {
this.customerServiceShow = false
this.customProblemShow = true
}
}
}



// WEBPACK FOOTER //
// ./src/components/LinkCustomerService.vue